import React from 'react';

// A quiet scrollbar for the detail panels, in the brand green.
//
// The thumb rests at a desaturated green rather than #16A34A itself: a
// full-strength brand colour on a bar you only glance at competes with the
// things that actually use green to mean something — the active nav row, a
// primary button. It deepens to the true brand green on hover, when you are
// looking at it on purpose.
//
// The default OS scrollbar is a wide grey trough with a squared thumb. Inside
// a rounded white dialog it reads as a seam down the right edge rather than a
// control, which is what makes an otherwise finished panel look unfinished.
//
// This cannot live in an inline style: ::-webkit-scrollbar is a pseudo-element
// and React's style prop only sets properties on the element itself. So it is
// a real stylesheet, scoped to one class name.
//
// Usage — add the class to whatever scrolls, and render this once on the page:
//
//   <ScrollStyle />
//   <div className="pv-scroll" style={{ overflowY: 'auto' }}>…</div>
//
// Firefox gets `scrollbar-width: thin`, which is the only knob it exposes;
// everything else gets the full treatment. Both are progressive — a browser
// that supports neither simply keeps its native bar, and nothing breaks.
const ScrollStyle = () => (
  <style>{`
    .pv-scroll {
      scrollbar-width: thin;
      scrollbar-color: #A7D8BA transparent;
    }
    .pv-scroll::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    .pv-scroll::-webkit-scrollbar-track {
      background: transparent;
    }
    .pv-scroll::-webkit-scrollbar-thumb {
      background: #A7D8BA;
      border-radius: 999px;
      /* The border is transparent and the background is clipped to the padding
         box, which insets the thumb without needing a narrower track. */
      border: 2px solid transparent;
      background-clip: padding-box;
    }
    .pv-scroll::-webkit-scrollbar-thumb:hover {
      background: #16A34A;
      background-clip: padding-box;
      border: 2px solid transparent;
    }
    .pv-scroll::-webkit-scrollbar-corner {
      background: transparent;
    }
  `}</style>
);

export default ScrollStyle;